<h2>Search preferences</h2>
<form [formGroup]="stepFormGroup">
  <shared-form-field-wrapper
    class="rate-type"
    label="Initial rate type"
    [formControl]="stepFormGroup.controls.initialInterestRateType">
    <shared-select-button
      [multiple]="true"
      [options]="mortgageInterestRateSelectItems"
      [formControl]="stepFormGroup.controls.initialInterestRateType" />
  </shared-form-field-wrapper>
  <shared-form-field-wrapper
    label="Initial rate period (years)"
    [formControl]="stepFormGroup.controls.comparisonPeriod">
    <shared-slider
      [formControl]="stepFormGroup.controls.comparisonPeriod"
      [range]="true"
      [min]="1"
      [max]="10"
      [step]="1" />
  </shared-form-field-wrapper>
  <shared-form-field-wrapper
    label="Name this search for future reference"
    [formControl]="stepFormGroup.controls.smartSearchName"
    name="smart-search-name">
    <shared-input-text
      name="smart-search-name"
      [formControl]="stepFormGroup.controls.smartSearchName" />
  </shared-form-field-wrapper>
</form>
<cp-stepper
  class="stepper"
  [forwardButtonEnabled]="stepFormGroup.valid"
  [hideProgressBar]="true"
  [showForwardButtonIcon]="false"
  forwardButtonLabel="Create smart search"
  [hideBackButton]="!isBackButtonVisible"
  [showSkipButton]="false"
  [loading]="isSaving"
  (forward)="emitNextClicked()"
  (back)="emitBackClicked()" />
